
import makerjs from "makerjs";


//已知劣弧上两点坐标及半径，求圆心坐标劣弧中心点坐标。
function optimizedArcMidpoint(start, end, radius) {
  // 1. 预计算差值避免重复计算
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const dSquared = dx * dx + dy * dy;

  // 快速检查半径有效性
  if (dSquared > 4 * radius * radius) return null; // 使用平方比较避免开方运算

  // 2. 计算中点（仅需一次加法运算）
  const midX = (start.x + end.x) * 0.5;
  const midY = (start.y + end.y) * 0.5;

  // 3. 计算垂直向量（优化单位化过程）
  const invD = 1 / Math.sqrt(dSquared);
  const ux = dy * invD;  // 单位垂直向量x分量
  const uy = -dx * invD; // 单位垂直向量y分量

  // 4. 计算圆心（单解模式，直接选择劣弧圆心）
  const h = Math.sqrt(radius * radius - dSquared * 0.25);
  const center = {
    x: midX + h * ux,
    y: midY + h * uy
  };

  // 5. 向量法计算中点（优化单位化过程）
  const v1x = start.x - center.x;
  const v1y = start.y - center.y;
  const v2x = end.x - center.x;
  const v2y = end.y - center.y;

  // 单位向量相加
  const sumX = v1x + v2x;
  const sumY = v1y + v2y;
  const invLen = radius / Math.sqrt(sumX * sumX + sumY * sumY);

  return {
    x: center.x + sumX * invLen,
    y: center.y + sumY * invLen
  };
}

function C42(model, zoom, Param, fixedParam) {
  //w,h,w1,w2
  console.log("Param==", Param[0].param);
  console.log("Param==", Param[1].param);
  console.log("Param==", Param);
  var plate = model.plate, markers = model.markers, myZoom = zoom * 1,
    W = Param[0].param, H = Param[1].param, H1 = Param[2].param, H2 = Param[3].param, W1 = Param[4].param, W2 = Param[5].param, R1 = Param[6].param, R2 = Param[7].param,
    //  plate = model.plate, markers = model.markers,
    markShift = fixedParam.markShift * 1, markShiftTwo = fixedParam.markShiftTwo * 1,
    markShiftThree = fixedParam.markShiftThree * 1, markShiftFour = fixedParam.markShiftFour * 1, markHolesOneD = fixedParam.markHolesOneD * 1,

    h = H * 1 * myZoom,
    h1 = H1 * 1 * myZoom,
    h2 = H2 * 1 * myZoom,
    w = W * 1 * myZoom,
    w1 = W1 * 1 * myZoom,
    w2 = W2 * 1 * myZoom,
    r1 = R1 * 1 * myZoom,
    r2 = R2 * 1 * myZoom,
    w3 = w - w1 - w2,
    // x0 = X*1*myZoom,
    // y0 = Y*1*myZoom;

    x0 = 0, x1 = 0, x2 = w1, x3 = w - w2, x4 = w, x5 = w,
    y0 = 0, y1 = h1, y2 = h, y3 = h, y4 = h2, y5 = 0,
    glassH = h, glassW = w;


  const start1 = { x: x1, y: y1 };
  const end1 = { x: x2, y: y2 };
  const radius1 = r1;
  // const midpoint = calculateArcMidpoint(start, end, radius);
  const midpoint1 = optimizedArcMidpoint(start1, end1, radius1);
  console.log("输出劣弧中点坐标start1=", start1); // 输出劣弧中点坐标
  console.log("输出劣弧中点坐标end1=", end1); // 输出劣弧中点坐标
  console.log("输出劣弧中点坐标=", midpoint1); // 输出劣弧中点坐标
  //  var aa=Circle_Center(x1,y1,x2,y2,r);
  //  console.log("aa====",aa);
  var xm1 = midpoint1.x, ym1 = midpoint1.y;

  console.log("输出劣弧中点坐标xm1,ym1=", xm1, ym1); // 输出劣弧中点坐标   
  const start2 = { x: x3, y: y3 };
  const end2 = { x: x4, y: y4 };
  const radius2 = r2;
  // const midpoint = calculateArcMidpoint(start, end, radius);
  const midpoint2 = optimizedArcMidpoint(start2, end2, radius2);
  console.log("输出劣弧中点坐标start2=", start2); // 输出劣弧中点坐标
  console.log("输出劣弧中点坐标end2=", end2); // 输出劣弧中点坐标
  console.log("输出劣弧中点坐标=", midpoint2); // 输出劣弧中点坐标
  //  var aa=Circle_Center(x1,y1,x2,y2,r);
  //  console.log("aa====",aa);
  var xm2 = midpoint2.x, ym2 = midpoint2.y;
  console.log("输出劣弧中点坐标xm1,ym1=", xm2, ym2); // 输出劣弧中点坐标

  if (h !== 0) {
    var TxtH = H;
  } if (h2 !== 0) {
    var TxtH2 = H2;
  } if (h1 !== 0) {
    var TxtH1 = H1;
  } if (w !== 0) {
    var TxtW = W;
  } if (w1 !== 0) {
    var TxtW1 = W1;
  } if (w2 !== 0) {
    var TxtW2 = W2;
  } if (w3 !== 0) {
    var TxtW3 = String(w3);
  } if (r1 !== 0) {
    var TxtR1 = R1;
  } if (r2 !== 0) {
    var TxtR2 = R2;
  }



  var drawAbnormalShapeC42 = {
    paths: {
      "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
      "LeftArc": new makerjs.paths.Arc([x1, y1], [x2, y2], r1, false, true),
      "TopLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
      "RightArc": new makerjs.paths.Arc([x3, y3], [x4, y4], r2, false, true),
      "RightLine": new makerjs.paths.Line([x4, y4], [x5, y5]),
      "BottomLine": new makerjs.paths.Line([x5, y5], [x0, y0]),
    }
  };
  var drawAbnormalShapeC42MarkH = {
    paths: {
      "LeftLine": new makerjs.paths.Line([x0 - 4 * markShift, y0], [x0 - 4 * markShift, y2]),
      "LeftShortUpline": new makerjs.paths.Line([x0, y2], [x0 - 5 * markShift, y2]),
      "LeftShortDnline": new makerjs.paths.Line([x0, y0], [x0 - 5 * markShift, y0]),
    }
  };
  var drawAbnormalShapeC42MarkH1 = {
    paths: {
      "LeftLine": new makerjs.paths.Line([x0 - markShift, y0], [x0 - markShift, y1]),
      "LeftShortUpline": new makerjs.paths.Line([x1, y1], [x0 - 2 * markShift, y1]),
      "LeftShortDnline": new makerjs.paths.Line([x0, y0], [x0 - 2 * markShift, y0]),
    }
  };
  var drawAbnormalShapeC42MarkH2 = {
    paths: {
      "RightLine": new makerjs.paths.Line([x4 + markShift, y4], [x4 + markShift, y5]),
      "RightShortUpline": new makerjs.paths.Line([x4, y4], [x4 + 2 * markShift, y4]),
      "RightShortDnline": new makerjs.paths.Line([x5, y5], [x5 + 2 * markShift, y5]),
    }
  };
  var drawAbnormalShapeC42MarkW = {
    paths: {
      "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x5, y5 - markShift]),
      "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
      "BotmShortRTline": new makerjs.paths.Line([x5, y5], [x5, y5 - 2 * markShift]),
    }
  };
  var drawAbnormalShapeC42MarkW1 = {
    paths: {
      "BottomLine": new makerjs.paths.Line([x0, y2 + markShift], [x2, y2 + markShift]),
      "BotmShortLfline": new makerjs.paths.Line([x0, y2], [x0, y2 + 2 * markShift]),
      "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
    }
  };
  var drawAbnormalShapeC42MarkW2 = {
    paths: {
      "BottomLine": new makerjs.paths.Line([x3, y3 + markShift], [x4, y3 + markShift]),
      "BotmShortLfline": new makerjs.paths.Line([x3, y3], [x3, y3 + 2 * markShift]),
      "BotmShortRTline": new makerjs.paths.Line([x4, y3], [x4, y3 + 2 * markShift]),
    }
  };
  var drawAbnormalShapeC42MarkW3 = {
    paths: {
      "BottomLine": new makerjs.paths.Line([x2, y2 + markShift], [x3, y3 + markShift]),
      "BotmShortLfline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
      "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 + 2 * markShift]),
    }
  };
  var drawAbnormalShapeC42MarkR1 = {
    paths: {
      "RLine": new makerjs.paths.Line([xm1, ym1], [xm1+r1/4, ym1-r1/4]),
    }
  };
  var drawAbnormalShapeC42MarkR2 = {
    paths: {
      "RLine": new makerjs.paths.Line([xm2, ym2], [xm2-r1/4, ym2-r1/4]),
    }
  };
  makerjs.model.addCaption(drawAbnormalShapeC42MarkW, TxtW, [x0, y0 - 2 * markShift], [x5, y5 - 2 * markShift]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC42MarkW1, TxtW1, [x1, y2 + 2 * markShift], [x2, y2 + 2 * markShift]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC42MarkW3, TxtW3, [x2, y2 + 2 * markShift], [x3, y3 + 2 * markShift]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC42MarkW2, TxtW2, [x3, y3 + 2 * markShift], [x4, y3 + 2 * markShift]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC42MarkH2, TxtH2, [x4 + 2 * markShift, y4], [x5 + 2 * markShift, y5]);//长度文字
  makerjs.model.addCaption(drawAbnormalShapeC42MarkH1, TxtH1, [x0 - 3 * markShift, y0], [x0 - 3 * markShift, y1]);//宽度文字
  makerjs.model.addCaption(drawAbnormalShapeC42MarkH, TxtH, [x0 - 5 * markShift, y0], [x0 - 5 * markShift, y2]);//宽度文字
  makerjs.model.addCaption(drawAbnormalShapeC42MarkR1, TxtR1, [xm1+r1/4, ym1-r1/4], [xm1+r1/4+4*markShift, ym1-r1/4]);//宽度文字
  makerjs.model.addCaption(drawAbnormalShapeC42MarkR2, TxtR2, [xm2-r1/4, ym2-r1/4], [xm2-r1/4-4*markShift, ym2-r1/4]);//宽度文字

  plate = {
    models: {
      drawAbnormalShapeC42: drawAbnormalShapeC42,
    }
  };
  markers = {
    models: {
      drawAbnormalShapeC42: drawAbnormalShapeC42,
      drawAbnormalShapeC42MarkH2: drawAbnormalShapeC42MarkH2,
      drawAbnormalShapeC42MarkH1: drawAbnormalShapeC42MarkH1,
      drawAbnormalShapeC42MarkH: drawAbnormalShapeC42MarkH,
      drawAbnormalShapeC42MarkW: drawAbnormalShapeC42MarkW,
      drawAbnormalShapeC42MarkW1: drawAbnormalShapeC42MarkW1,
      drawAbnormalShapeC42MarkW2: drawAbnormalShapeC42MarkW2,
      drawAbnormalShapeC42MarkW3: drawAbnormalShapeC42MarkW3,
      drawAbnormalShapeC42MarkR1: drawAbnormalShapeC42MarkR1,
      drawAbnormalShapeC42MarkR2: drawAbnormalShapeC42MarkR2,
    }
  };

  /*****************************************************************************/
  //return { plate, markers, glassW, glassH }

  return { w, h, plate, markers }
};


export default C42;